import {
  CircularProgress,
  Tooltip,
  circularProgressClasses,
} from "@mui/material";
import { base, gray } from "configs/colors";
import { shadows } from "configs/shadows";

import {
  BarContainer,
  BarValueWrapper,
  CircleContainer,
  CircleValueWrapper,
  BarProgress as MUIBarProgress,
} from "./Progress.styles";
import { BarProgressProps, CircleProgressProps } from "./Progress.types";
import { getCircularProgressPropsBasedOnSize } from "./Progress.utils";
import Typography from "../../atoms/Typography";

export const BarProgress: React.FC<BarProgressProps> = ({
  color,
  placement,
  value = 0,
}) => {
  return (
    <BarContainer placement={placement}>
      {placement === "hover" ? (
        <Tooltip
          title={<>{value}%</>}
          PopperProps={{
            sx: {
              "& .MuiTooltip-tooltip": {
                background: base.White,
                color: gray[700],
                border: `1px solid ${gray[200]}`,
                boxShadow: shadows.lg,
              },
            },
          }}
        >
          <MUIBarProgress color={color} value={value} variant="determinate" />
        </Tooltip>
      ) : (
        <MUIBarProgress color={color} value={value} variant="determinate" />
      )}
      {placement === "bottom-right" || placement === "right-center" ? (
        <BarValueWrapper className="progress-value">
          <Typography type="TextSM" fontWeight={500}>
            {value}%
          </Typography>
        </BarValueWrapper>
      ) : null}
    </BarContainer>
  );
};

export const CircleProgress: React.FC<CircleProgressProps> = ({
  color,
  size,
  value = 0,
}) => {
  return (
    <CircleContainer>
      <CircularProgress
        variant="determinate"
        sx={{ color: gray[200] }}
        value={100}
        thickness={4}
        {...getCircularProgressPropsBasedOnSize(size)}
      />
      <CircularProgress
        variant="determinate"
        disableShrink
        sx={{
          color: (theme) =>
            theme.palette[(color === "inherit" ? "grey" : color) as never][600],
          position: "absolute",
          left: 0,
          zIndex: 2,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        value={value}
        thickness={4}
        {...getCircularProgressPropsBasedOnSize(size)}
      />
      <CircleValueWrapper size={size}>{value}%</CircleValueWrapper>
    </CircleContainer>
  );
};
